import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M11.966 3a5.947 5.947 0 0 0-5.95 5.95v1.875c0 .608-.25 1.519-.562 2.037l-1.135 1.894c-.697 1.17-.214 2.474 1.072 2.903a20.85 20.85 0 0 0 13.158 0 1.983 1.983 0 0 0 1.073-2.903l-1.135-1.894c-.313-.518-.563-1.438-.563-2.037V8.95C17.915 5.68 15.235 3 11.966 3Z"
    />
    <path
      stroke="#A5A5AA"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M14.922 18.025A2.985 2.985 0 0 1 11.948 21a2.98 2.98 0 0 1-2.1-.875 2.98 2.98 0 0 1-.875-2.1"
    />
  </svg>
);
export default SvgNotification;
